import request from './axiosFun';
// 人员列表
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 内容管理查询
export function pageNotice(data) {
  return request({
    url: url + '/base-server/homeCenter/sysNotice/pageNotice',
    method: 'post',
    data
  });
}
// 内容管理统计查询
export function countNotice(data) {
  return request({
    url: url + '/base-server/homeCenter/sysNotice/countNotice',
    method: 'post',
    data
  });
}
// 内容管理新增公告
export function saveNotice(data) {
  return request({
    url: url + '/base-server/homeCenter/sysNotice/saveNotice',
    method: 'post',
    data
  });
}
// 编辑内容管理
export function updateNotice(data) {
  return request({
    url: url + '/base-server/homeCenter/sysNotice/updateNotice',
    method: 'post',
    data
  });
}
// 批量删除
export function removeBatchNotice(data) {
  return request({
    url: url + '/base-server/homeCenter/sysNotice/removeBatchNotice',
    method: 'post',
    data
  });
}
// 养殖场列表
export function findFarmInfoList(data) {
  return request({
    url: url + '/pasture/farmInfo/findFarmInfoList',
    method: 'post',
    data
  });
}
// 报警关联查询
export function getPageWarningRoleRelation(data) {
    return request({
      url: url + '/pasture/warningInfo/getPageWarningRoleRelation',
      method: 'post',
      data
    });
  }
// 报警关联添加
export function saveWarningRoleRelation(data) {
  return request({
    url: url + '/pasture/warningInfo/saveWarningRoleRelation',
    method: 'post',
    data
  });
}
// 报警关联修改
export function updateWarningRoleRelation(data) {
  return request({
    url: url + '/pasture/warningInfo/updateWarningRoleRelation',
    method: 'post',
    data
  });
}
// 报警关联删除
export function delWarningRoleRelation(data) {
    return request({
      url: url + '/pasture/warningInfo/delWarningRoleRelation',
      method: 'post',
      data
    });
  }
  // 角色列表
export function selectPageAllRole(data) {
    return request({
      url: url + '/pasture/sys/selectPageAllRole',
      method: 'post',
      data
    });
  }
  // 通过角色ID查询用户信息
export function selectUsersByRoleId(data) {
    return request({
      url: url + '/pasture/sys/selectUsersByRoleId',
      method: 'post',
      data
    });
  }
    // 固定牧场接口
export function getBafuFarmInfo(data) {
    return request({
      url: url + '/pasture/userPermission/getBafuFarmInfo',
      method: 'post',
      data
    });
  }
        // 养殖规程管理列表统计文档
export function countDocument(data) {
    return request({
      url: url + '/project-server/bf/institution/countDocument',
      method: 'post',
      data
    });
  }
      // 养殖规程管理列表
export function pagesDocument(data) {
    return request({
      url: url + '/project-server/bf/institution/pagesDocument',
      method: 'post',
      data
    });
  }
   // 养殖规程管理新增
export function saveDocument(data) {
    return request({
      url: url + '/project-server/bf/institution/saveDocument',
      method: 'post',
      data
    });
  }
   // 养殖规程管理编辑
export function updateDocument(data) {
    return request({
      url: url + '/project-server/bf/institution/updateDocument',
      method: 'post',
      data
    });
  }
     // 养殖规程管理删除
export function removeDocument(data) {
    return request({
      url: url + '/project-server/bf/institution/removeDocument',
      method: 'post',
      data
    });
  }
       // 分类管理删除
export function addCategory(data) {
    return request({
      url: url + '/project-server/bf/category/addCategory',
      method: 'post',
      data
    });
  }
       // 分类管理删除
export function updateCategory(data) {
    return request({
      url: url + '/project-server/bf/category/updateCategory',
      method: 'post',
      data
    });
  }
       // 分类管理删除
export function deleteCategory(data) {
    return request({
      url: url + '/project-server/bf/category/deleteCategory',
      method: 'post',
      data
    });
  }
         // 分类管理列表
export function listCategory(data) {
    return request({
      url: url + '/project-server/bf/category/list',
      method: 'post',
      data
    });
  }





// WEBPACK FOOTER //
// ./src/api/systemManagement.js